import { createSlice } from '@reduxjs/toolkit';

interface ProfileSidebarState {
  isProfileSidebarOpen: boolean;
}

const initialState: ProfileSidebarState = {
  isProfileSidebarOpen: false,
};

export const profileSidebarSlice = createSlice({
  name: 'profileSidebar',
  initialState,
  reducers: {
    toggleProfileSidebar: (state) => {
      state.isProfileSidebarOpen = !state.isProfileSidebarOpen;
    },
  },
});

export const { toggleProfileSidebar } = profileSidebarSlice.actions;
export default profileSidebarSlice.reducer; 